var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutDefault',{attrs:{"variant":"black"}},[_c('div',{staticClass:"bg-white mt-56 md:mt-80 mb-20"},[_c('OrganismProject')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }